import React, { useCallback, useEffect, useState } from 'react';
import { Button, Layout, Modal, Popover, Tooltip } from 'antd';
import { useAtom, useAtomValue } from 'jotai';
import { Scrollbars } from 'react-custom-scrollbars';

import { MenuContent } from '@components/layout';
import { DARK_THEME, SIDE_NAV_WIDTH } from '@src/constants/constant';
import { NavigationTypes } from '@src/types/types';
import {
  themeCurrentThemeAtom,
  themeMobileNavAtom,
  themeNavCollapsedAtom,
} from '@src/store/theme';
import { BulbFilled, BulbOutlined, BookOutlined } from '@ant-design/icons';
import useLogout from '@hooks/auth/useLogout';
import utils from '@src/utils/utils';
import { useQuery } from '@tanstack/react-query';
import { ApiService, TeambinderApiService } from '@src/api';
import { isMobile } from 'react-device-detect';
import Utils from '@src/utils/utils';
import { IcoMyActive, IcoMyInactive } from '@src/assets/svg';
import { useNavigate } from 'react-router-dom';

const { Sider } = Layout;
const { confirm } = Modal;

export const SideNav = () => {
  const navigate = useNavigate();
  const isMobile = Utils.isMobile();
  const navCollapsed = useAtomValue(themeNavCollapsedAtom);
  const [currentTheme, setCurrentTheme] = useAtom(themeCurrentThemeAtom);

  const [openTooltip, setOpenTooltip] = useState(false);
  useEffect(() => {
    TeambinderApiService.getBinderMember().then((res) => {
      if (!res.data?.mobile && location.pathname !== '/app/my') {
        setTimeout(() => {
          setOpenTooltip(true);
        }, 2000);
      }
    });
  }, [location.pathname]);

  const handleClickSetTheme = useCallback(() => {
    if (currentTheme === 'dark') {
      setCurrentTheme('light');
    } else {
      setCurrentTheme('dark');
    }
  }, [setCurrentTheme, currentTheme]);

  return (
    <Sider
      className={`side-nav`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed && isMobile}
    >
      <Scrollbars autoHide>
        <MenuContent />
        <div className={'bottom-button-wrap'}>
          {/* <div className={'mr-4'}>
            <Button onClick={handleOnClick}>로그아웃</Button>
          </div> */}

          <div>
            <Tooltip
              open={openTooltip}
              color="#444"
              title={
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '13px',
                  }}
                >
                  핸드폰 번호 등록하고 <br />
                  키워드 소식 알림 받아보세요!
                </div>
              }
            >
                <Button
                  onClick={() => {
                    navigate('/app/my');
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '6px 12px',
                    marginRight: '14px',
                  }}
                >
                  설정
                </Button>
            </Tooltip>
          </div>
          <div>
              <Button
                onClick={() => {
                  window.open('https://blog.teambinder.ai/binder-essential-guide', '_blank');
                }}
                style={{
                  padding: '6px 12px',
                  marginRight: '14px',
                }}
              >
                가이드
              </Button>
          </div>
        </div>
      </Scrollbars>
    </Sider>
  );
};
